window.addEventListener('load', (()=>{
    Elevatione.init()
}))

Elevatione.init = function () {
    // $("#shopify-section-footer-copy").remove();
    $('button[name="checkout"]').on('click', function () {
        $('.load-3p').show()
        $(this).html('')
    })
    Elevatione.initializeLoanProviders()
}

Elevatione.detectLocation = function () {
    let request = new XMLHttpRequest();
    request.open('GET', 'https://api.ipdata.co/?api-key=1fd3fb0ffdc7f6a0b091f53f7d42d130ab3a0ef042ab3f6f8b3c99e1', false);
    request.setRequestHeader('Accept', 'application/json');
    request.send();
    return JSON.parse(request.responseText)
}

Elevatione.allowedLoanProviders = function () {
    //return ["afterpay"]
    Elevatione.ipLocation = Elevatione.detectLocation()

    if (Elevatione.ipLocation.country_code == 'US' && (Elevatione.cart.total_price / 100) < 600) {
        let rotate = JSON.parse(sessionStorage.getItem('allowedLoanProviders') || '["affirm", "afterpay"]')
        rotate = rotate[0] == 'affirm' ? ["afterpay"] : ["affirm"]
        sessionStorage.setItem('allowedLoanProviders', JSON.stringify(rotate))
        return rotate
    } else if (Elevatione.ipLocation.country_code == 'US' && (Elevatione.cart.total_price / 100) >= 600) {
        return ["affirm"]
    }
    return ['splitt']
}

Elevatione.initializeLoanProviders = function () {
    if (Elevatione.cart.is_subscription) {
        $('#loan-providers').remove()
        return false;
    }

    $('#default-prod-price-para').remove()

    for (let i = 0; i < Elevatione.loanProviders.length; i++) {
        if (Elevatione.loanProviders[i] == 'affirm') {
            let affirmhtml = '<div class="loan-providers-single col-sm-7" id="affirm-payment">'
            affirmhtml += '<p class="affirm-as-low-as roboto-regular affirm-para" data-page-type="product" data-amount="' + (Elevatione.cart.total_price ) + '"></p>'
            affirmhtml += '</div>'
            $('#loan-providers').append(affirmhtml)
            setTimeout( function () {
                Elevatione.initializeAffirm()
                setTimeout(function () {
                    $('.affirm-ala-price').html(Shopify.format_money(parseInt($('.affirm-ala-price').html().replace('$','')) * 100, theme.moneyFormat))
                })
            })
        }
        if (Elevatione.loanProviders[i] == 'afterpay') {
            let afterpay = '<div class="loan-providers-single col-sm-7"><div id="afterpay-payment"></div></div>'
            $('#loan-providers').append(afterpay)
            setTimeout( function () {
                Afterpay.init($)
            })
        }
        if (Elevatione.loanProviders[i] == 'splitt') {
            Elevatione.calculateprice()
        }
    }
    if (!Elevatione.loanProviders.includes('splitt')) {
        $('.splitit-dynamic-container').remove()
    }

    if (!Elevatione.loanProviders.includes('afterpay')) {
        $('.afterpay-payment-container').remove()   
    }

    if (Elevatione.loanProviders.length == 1) {
        $('.loan-providers-single').removeClass('col-sm-4')
        $('.loan-providers-single').addClass('col-sm-4');
        $('.splitit-dynamic-container').addClass('col-sm-7');
    }

    $('.saso-summary').hide()
}

Elevatione.calculateprice = function () {
    var dataprice = parseInt($('.price-content').attr('data-price'));
    var calculatedprice = parseInt(dataprice / 100);
    var emi_installment = parseInt($('.emi_id').attr('data-emi'));
    // Retrieve the object from storage
    var retrievedObject = localStorage.getItem('emi_installment');
    var calculatedtotalprice = (parseFloat(calculatedprice / emi_installment)).toFixed(2);
    $('.price-content').html(Shopify.format_money(calculatedtotalprice, Elevatione.currency_format))
    $('.splitit-dynamic-container').show()
}


Elevatione.initializeAffirm = function () {
    let _affirm_config = {
        public_api_key:  "AVOFSDUHU65AP4IU",
        script:          "https://cdn1.affirm.com/js/v2/affirm.js",
        session_id:      "YOUR_VISITOR_SESSION_ID"
    };
    (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
    // Use your live public API Key and https://cdn1.affirm.com/js/v2/affirm.js script to point to Affirm production environment.
}